export class OrderComplainModel {
    public amount!: string;
    public amountNDT!: number;
    public complainText!: string;
    public transactionCode!: string;
    public createBy!: string;
    public createDate!: string;
    public exchangeRate!: number;
    public id!: number;
    public img!: string;
    public files!: string;
    public isBroken!: boolean;
    public isMissGood!: boolean;
    public isOption!: boolean;
    public isLoss!: boolean;
    public isOther!: boolean;
    public modifiedBy!: string;
    public modifiedDate!: string;
    public noteForUser!: any;
    public noteOfStaff!: any;
    public orderId!: number;
    public orderType!: number;
    public receivedId!: number;
    public resMethod!: number;
    public status!: number;
    public statusObj!: any;
    public uId!: number;
    public userName!: string;
    public productIds: number[] = [];
}
